import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    companyName: '',
    workEmail: '',
    phoneNumber: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    // Clear submit error when user starts typing
    if (submitError) {
      setSubmitError('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    if (!formData.workEmail.trim()) {
      newErrors.workEmail = 'Work email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.workEmail)) {
      newErrors.workEmail = 'Please enter a valid email address';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsSubmitting(true);
      setSubmitError('');

      try {
        // const response = await fetch('http://localhost:5000/api/contact', {
        const response = await fetch('https://hook.us2.make.com/pl383n1n6o6z3tyxwnblmxj2m5t4fpu6', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        // const result = await response.json();
        const result = response

        // if (response.ok && result.success) {
        if (response.ok && result.status === 200) {
          setIsSubmitted(true);
          // Reset form data
          setFormData({
            fullName: '',
            companyName: '',
            workEmail: '',
            phoneNumber: '',
            message: ''
          });
        } else {
          setSubmitError(result.message || 'Failed to submit form. Please try again.');
        }
      } catch (error) {
        console.error('Submission error:', error);
        if (error.name === 'TypeError' && error.message.includes('CORS')) {
          setSubmitError('CORS error: Please make sure the server is running and CORS is properly configured.');
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
          setSubmitError('Network error: Unable to connect to the server. Please check if the server is running on port 5000.');
        } else {
          setSubmitError('Network error. Please check your connection and try again.');
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const contactDetails = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      label: 'Address',
      text: '2801 N Monroe St, Tallahassee, FL 32303'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      label: 'Email',
      text: 'msltechsolutions71383@gmail.com'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      ),
      label: 'Phone',
      text: '+1 (850) 273-6451'
    }
  ];

  return (
    <main>
      {/* Page Header Section */}
      <section className="page-header">
        <div className="page-header-bg">
          <div className="contact-connection-bg"></div>
        </div>
        <div className="page-header-content">
          <h1 className="page-header-title">Let's Get in Touch</h1>
          <p className="page-header-subtitle">
            We're ready to answer your questions and discuss how our AI and Cloud solutions can transform your business.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="contact-main-section">
        <div className="container">
          <div className="contact-grid">
            {/* Left Column: Contact Details */}
            <div className="contact-details-column">
              <h2 className="contact-section-title">Contact Details</h2>

              <div className="contact-info-list">
                {contactDetails.map((detail, index) => (
                  <div key={index} className="contact-info-item">
                    <div className="contact-icon">
                      {detail.icon}
                    </div>
                    <div className="contact-text">
                      <span className="contact-label">{detail.label}</span>
                      <span className="contact-value">{detail.text}</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Google Map */}
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.1804425440796!2d-84.30568687402136!3d30.481243897742676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88ecf5d16e2c3e13%3A0x340cee921e926b6c!2s2801%20N%20Monroe%20St%2C%20Tallahassee%2C%20FL%2033825!5e1!3m2!1sen!2sus!4v1757277668827!5m2!1sen!2sus"
                  width="100%"
                  height="300"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="MSL Tech Solutions Office Location"
                ></iframe>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="contact-form-column">
              <h2 className="contact-section-title">Let's Discuss Your AI & Automation Goals</h2>

              {!isSubmitted ? (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="fullName" className="form-label">
                      Full Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      className={`form-input ${errors.fullName ? 'error' : ''}`}
                      placeholder="Enter your full name"
                      required
                    />
                    {errors.fullName && <span className="error-message">{errors.fullName}</span>}
                  </div>

                  <div className="form-group">
                    <label htmlFor="companyName" className="form-label">
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Enter your company name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="workEmail" className="form-label">
                      Work Email <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="workEmail"
                      name="workEmail"
                      value={formData.workEmail}
                      onChange={handleInputChange}
                      className={`form-input ${errors.workEmail ? 'error' : ''}`}
                      placeholder="Enter your work email"
                      required
                    />
                    {errors.workEmail && <span className="error-message">{errors.workEmail}</span>}
                  </div>

                  <div className="form-group">
                    <label htmlFor="phoneNumber" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Enter your phone number"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="form-label">
                      How can we help you? <span className="required">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      className={`form-textarea ${errors.message ? 'error' : ''}`}
                      placeholder="Tell us about your project, goals, or questions..."
                      rows="5"
                      required
                    ></textarea>
                    {errors.message && <span className="error-message">{errors.message}</span>}
                  </div>

                  <button type="submit" className="submit-button" disabled={isSubmitting}>
                    {isSubmitting ? 'Sending...' : 'Submit Request'}
                  </button>

                  {submitError && (
                    <div className="error-message-container">
                      <span className="error-message">{submitError}</span>
                    </div>
                  )}
                </form>
              ) : (
                <div className="success-message">
                  <div className="success-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="success-headline">Thank You!</h3>
                  <p className="success-text">
                    Your message has been sent successfully. Our team will review your request and get back to you within 24 business hours.
                  </p>
                  <button
                    className="submit-button"
                    onClick={() => setIsSubmitted(false)}
                  >
                    Send Another Message
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
